import { useGetQuizzesQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { quizzesColumns, type QuizRow } from '../constants/quizzesColumns';

export const QuizzesList = () => {
    const {
        loading: quizzesLoading,
        data: quizzesData,
        error: quizzesError,
        refetch,
        fetchMore,
    } = useGetQuizzesQuery({
        variables: { offset: 0 },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    if (quizzesError) {
        throw new Error('Une erreur est survenue lors de la récupération des quiz');
    }

    const hasMore = quizzesData?.quizzes.hasMore ?? false;
    const quizzes = quizzesData?.quizzes.quizzes ?? [];

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<QuizRow>
                columns={quizzesColumns}
                data={quizzes}
                filterMode="server"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/quiz/${row._id}`}
                hasMore={hasMore}
                isLoading={quizzesLoading}
                refetch={async (vars) => {
                    await refetch({ ...vars });
                }}
                fetchMore={async (opts) => {
                    await fetchMore({ variables: opts.variables });
                }}
                emptyMessage="Aucun quiz n'a été trouvé"
            />
        </div>
    );
};
